import React from 'react';

const logoUrl = '/logo footer.png'; // Replace with your logo path
const instagramUrl = 'https://www.instagram.com/bandland.in/';
const facebookUrl = 'https://www.facebook.com/Bandland.in/';
const youtubeUrl = 'https://www.youtube.com/@BandlandIndia';
const twitterUrl = 'https://twitter.com/BandlandIndia';

// The social icons are on different lines because the <a> tags are inline but the parent <div> does not enforce horizontal layout. In HTML, whitespace or line breaks between inline/inline-block elements can sometimes cause them to wrap, especially if the container is not wide enough or if the icons have display: block or similar styles. Using flexbox (with Tailwind's flex classes) ensures they stay in a row.

const Footer = () => (
    <footer
     style={{
         backgroundImage: "url('/pattern footer.png')",
         fontFamily: 'Poppins, sans-serif'
    }} className="bg-[#440A06] min-h-[30vh] md:min-h-[100vh] relative text-white text-center py-8">
        {/* Logo */}
        <img 
              src='/footer (2).png' 
              alt='Footer' 
              className='w-full absolute h-auto top-[-33%] md:top-[-19vw]' 
            />
        <div className='flex justify-center'>
            
            <img
                src={logoUrl}
                alt="Logo"
                className="w-[180px] md:w-[365px] h-auto object-contain mt-[15vw] md:mt-[17vw] block"
                
            />
        </div>
        {/* Social Icons */}
        <div className="flex justify-center items-center gap-5 my-[6vw] md:my-[40px]">
            <a href={instagramUrl} target="_blank" rel="noopener noreferrer">
                <img src="/INSTAGRAM.png" alt="Instagram" className="w-4 h-4 md:w-7 md:h-7 " />
            </a>
            <a href={facebookUrl} target="_blank" rel="noopener noreferrer">
                <img src="/FACEBOOK.png" alt="Facebook" className="w-4 h-4 md:w-7 md:h-7 " />
            </a>
            <a href={youtubeUrl} target="_blank" rel="noopener noreferrer">
                <img src="/Vector (3).png" alt="YouTube" className="w-4 h-4 md:w-7 md:h-7 " />
            </a>
            <a href={twitterUrl} target="_blank" rel="noopener noreferrer">
                <img src="/Vector (2).png" alt="Twitter" className="w-4 h-4 md:w-7 md:h-7 " />
            </a>
        </div>
        {/* Links */}
        <div className="mt-4 text-[10px] flex justify-center items-center gap-[10px] md:gap-[40px] md:text-[12px]">
            <a href="https://drive.google.com/file/d/1sh4XL3gvfAlXmq5agY8BjQ4pOG8YUTef/view" target='_blank' rel="noopener noreferrer"  className="text-white  font-semibold  text-[12px] md:text-[18px] lg:text-[20px]">Privacy</a>
            <div className="w-[1px] md:w-[2px] h-[20px] md:h-[25px]  bg-white"> </div>
            <a href="mailto:bandland.help@bookmyshow.com" target='_blank' rel="noopener noreferrer" className="text-white  font-semibold text-[12px] md:text-[18px] lg:text-[20px]">Contact Us</a>
            <div className="w-[1px] md:w-[2px] h-[20px] md:h-[25px]   bg-white"> </div>
            <a href="https://in.bookmyshow.com/events/bandland-2026/ET00466059" target='_blank' rel="noopener noreferrer" className="text-white  font-semibold text-[12px] md:text-[18px] lg:text-[20px]">Terms & Conditions</a>
        </div>
    </footer>
);

export default Footer;